import {
  Component,
  OnInit,
  ViewEncapsulation,
  NgZone,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  AbstractControl,
} from '@angular/forms';
import { emailValidator, mustMatch } from '../utils/app-validators';
import Swal from 'sweetalert2';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { JwtHelperService } from '@auth0/angular-jwt';
import { find, get, pull } from 'lodash';
import { DatePipe } from '@angular/common';
// import {Title} from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { GooglePlaceDirective } from 'node_modules/ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
declare const google: any;
declare module 'googlemaps';
import {
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
import { MapsAPILoader } from '@agm/core';

@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class UserRegistrationComponent implements OnInit {
  @Input() googleAdressType: any;
  @ViewChild('addresstext') addresstext: ElementRef;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild("addresstextNew") addresstextNew: any;

  showSpinner: Boolean = true;
  spinnerType = SPINNER.circle;
  public form: FormGroup;
  public formBusiness: FormGroup;
  public communitySearch: FormGroup;
  public addressMain: FormGroup;
  public alternateAddress: FormGroup;
  public search: any;
  public isTitle:boolean = false;
  public isDescription = false;
  public affiliatedId: any;
  public faithId: any;
  public businessIds = [];
  public name: any;
  public defaultFaithId:any
  public affiliation: any;
  public isBusinessContactNameVisible = false;
  public isChecked: any;
  @ViewChild('tagInput') tagInputRef: ElementRef;
  public tags = [];
  @ViewChild('myModal') modalClose;
  @ViewChild('placesRef') placesRef: GooglePlaceDirective;
  error: string;
  public submitted = false;
  public id;
  public subscriptionPlanId: string;
  public valueAndFaith:any;
  public faithList: any = [];
  public bussinessList = [];
  public communityList: [];
  public toppingList = [];
  public toppings: any;
  public profilePic: any;
  public coverPhoto: any;
  public bussiness = [];
  public custCategories = [];
  public loading = false;
  public address = {};
  public alternateAddresses = [];
  public user: any;
  public userData: any;
  public itemsAsObjects: any;
  comAffModel: NgbModalRef;
  businessModel: NgbModalRef;
  profileModel: NgbModalRef;
  faithModel: NgbModalRef;
  commuinityModel: NgbModalRef;
  addModel: NgbModalRef;
  socialLinksModel: NgbModalRef;
  public addressLocation: any;
  hasGoogleSelection: boolean = false;
  addresses: FormArray;
  category: FormArray;
  showDiv = false;
  Sunday: FormArray;
  Monday: FormArray;
  Tuesday: FormArray;
  Wednesday: FormArray;
  Thursday: FormArray;
  Friday: FormArray;
  Saturday: FormArray;
  public isAddress: any;
  // public title: any;
  public isEmail: any;
  public isName: any;
  time = { hour: 13, minute: 30 };
  meridian = true;
  rate;
  lat;
  lng;
  defaultBounds;
  boundsLimit = true;
  options;
  title: string = 'AGM project';
  latitude: number;
  longitude: number;
  zoom: number;
  finish;
  start;
  isMeridian = false;
  readonly = true;
  bhours: any;
  subscriptionPlans: any;
  private geoCoder;
  user$: any = {};
  isTerms: boolean = true;
  isEdit: boolean = false;
  descriptionLabel: any = 'Click to edit field label';
  planType: string;
  planName: any;
  selectedPlan: any;
  newBusinessList: any;
  newBussinessListData: any = [];
  selectedFaith: string = '';
  selectedFaith2: string = '';
  selectedFaith3: string = '';
  faithListLevel2: any = [];
  faithListLevel3: any = [];
  skip: number = 0;
  skip1: number = 0;
  limit: number = 1000;
  limit1: number = 1000;
  totalItems1: number = 0;
  isShowStreetAddress: boolean = false;
  ministryDetailsForm: FormGroup;
  ministryAddress: { address2: any; city: any; state: any; postalCode: any; country: any; location: { type: string; coordinates: any; }; isHidePhone: boolean; };
  address2: any;
  checkLabel = false
  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngxService: NgxUiLoaderService,
    private zone: NgZone,
    private modalService: NgbModal,
    public router: Router,
    public fb: FormBuilder,
    public authenticationService: AuthenticationService,
    private datePipe: DatePipe
  ) {


  }

  ngOnInit(): void {
    this.getLocation();
    this.getSubscriptionPlanType();
    this.createCategory();
    this.isEmail = false;
    this.isName = false;
    this.valueAndFaith = "We profess Jesus Christ as Lord and conduct our affairs according to Biblical principles, managing our business with integrity and respect."
    this.alternateAddresses = [];
    this.user = JSON.parse(localStorage.getItem('merchant_currentUser1'));
    this.planType = localStorage.getItem('planType');
    let info = JSON.parse(localStorage.getItem('merchant_user'));
    this.form = this.fb.group({
      name: [info?.name, [Validators.required]],
      // photo: ['', [Validators.required]],
      // coverPhoto: ['', [Validators.required]],
      userName: ['', [Validators.required]],
      email: [info?.email, [Validators.required, Validators.email]],
      affiliatedBy: [''],
      contactNo: ['', []],
      faithName: [''],
      subfaithName: [''],
      subfaith2Name: [''],
      faith: ['', [Validators.required]],
      faith2: [''],
      faith3: [''],
      logLine: ['', []],
      website: ['', [Validators.required]],
      phonecode: ['', []],
      bussinessTypes: [''],
      bussinessHours: ['', []],
      address: ['', [Validators.required]],
      location: ['', []],
      shortBio: ['', [Validators.required, Validators.minLength(6)]],
      address2: ['', []],
      alternateAddresstext: [''],
      addresses: this.fb.array([]),
      category: this.fb.array([]),
      subscriptionPlanType: [''],
      businessUserName : ['', [Validators.required, this.noWhitespaceOrSpecialCharacter, Validators.minLength(6)] ],
      iosAppStoreLink: [''],
      androidAppStoreLink: [''],
      facebookLink: [''],
      instagramLink: [''],
      youtubeLink: [''],
      linkedinLink: [''],
      tiktokLink: [''],
    });

    this.ministryDetailsForm = this.fb.group({
      name: ['', Validators.required],
      address: ['', Validators.required],
      phone: [''],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      companyWebsite: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)$'
          ),
        ],
      ],
      ein: [''],
    });


    this.addCategory();

    if (info && info.email) {
      this.isEmail = true;
    }
    if (info && info.name) {
      this.isName = true;
    }
    if (this.user.isFirstUpdateDone == false) {
      this.isTerms = true;
    }
    if (this.user && this.user.isFirstUpdateDone == true) {
      // this.getUserProfile();
      this.title = 'Update Profile';
      this.isTerms = false;
      this.isChecked = true;
    } else {
      this.title = 'Sign Up';
    }


    $('.collapse').collapse();
    // this.titleService.setTitle('Home | @angular-material-extensions/google-maps-autocomplete');
    // this.zoom = 10;
    // this.latitude = 52.520008;
    // this.longitude = 13.404954;

    // this.setCurrentPosition();
    let location = {};
    this.getFaithList();
    this.businessList("");
    // this.community('')
    this.searchCommunity('');
    this.addressMain = this.fb.group({
      streetAddress: [''],
      city: [''],
      state: [''],
      googleAddress: [''],
      postalCode: [''],
      country: [''],
      suite_no: [''],
      address_contact_no: [''],
      address_alternateContact_no: [''],
      location: [location, []],
    });
    this.alternateAddress = this.fb.group({
      streetAddress: [''],
      city: [''],
      state: [''],
      googleAddress: [''],
      postalCode: [''],
      country: [''],
      suite_no: [''],
      address_contact_no: [''],
      location: [location, []],
    });
    this.communitySearch = this.fb.group({
      areaCode: ['', []],
      city: ['', []],
      state: ['', []],
      country: ['', []],
      long: ['', []],
      lat: ['', []],
      search: ['', []],
      location: [location, []],
      faithName: ['', []],
      denominiation: ['', []],
      fellowship: ['', []],
      merchant: ['', []],
      bussinessTypes: ['', []],
    });
    this.formBusiness = this.fb.group({
      Sunday: this.fb.array([this.createSunItem()]),
      Monday: this.fb.array([this.createMonItem()]),
      Tuesday: this.fb.array([this.createTueItem()]),
      Wednesday: this.fb.array([this.createWedItem()]),
      Thursday: this.fb.array([this.createThurItem()]),
      Friday: this.fb.array([this.createFriItem()]),
      Saturday: this.fb.array([this.createSatItem()]),
    });


  }


  inputValue(event: any) {
    this.descriptionLabel = event;
  }

  getAddress(place: object) {
    this.address = place['formatted_address'];
  }

  getLocation() {
    // Fallback coordinates if user blocks location or it's unavailable
    const fallback = {
      lat: 34.275850357768306,
      lng: -118.60696568972055,
    };

    // Initialize default to fallback so address widgets have a center immediately
    this.defaultBounds = fallback;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (position) {
            this.defaultBounds = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
          }
        },
        // On error (permission denied, unavailable, timeout), stick with fallback
        (error) => {
          console.log('Geolocation error, using fallback coords:', error);
          this.defaultBounds = fallback;
        }
      );
    } else {
      this.defaultBounds = fallback;
      alert('Geolocation is not supported by this browser.');
    }
  }

  limitCheckbox(e) {
    if (e.target.checked) {
      this.boundsLimit = true;
      // let center = { lat: 30.7333, lng: 76.7794 };

      // this.defaultBounds = {
      //   north: center.lat + 0.1,
      //   south: center.lat - 0.1,
      //   east: center.lng + 0.1,
      //   west: center.lng - 0.1,
      // };
      // this.options = {
      //   bounds: this.defaultBounds,
      //   radius: '500000000',
      //   strictBounds: true,
      // }
    } else if (!e.target.checked) {
      this.boundsLimit = false;
    }
  }

  removeTag(tag): void {
    this.businessIds.splice(tag, 1);
    if (this.businessIds.length == 0) {
      this.form.controls['bussinessTypes'].setValue('');
    } else {
      this.form.controls['bussinessTypes'].setValue(
        this.businessIds[0].tagName
      );
    }
  }
  onKeyUp(event: KeyboardEvent): void {
    const inputValue: string = this.form.controls.tag.value;
    if (event.code === 'Backspace' && !inputValue) {
      // this.removeTag();
      return;
    } else {
      if (event.code === 'Comma' || event.code === 'Space') {
        // this.addTag(inputValue);
        this.form.controls.tag.setValue('');
      }
    }
  }
  createSunItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createMonItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createTueItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createWedItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createThurItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createFriItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createSatItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createItem() {
    return this.fb.group({
      streetAddress: [''],
      city: [''],
      location: [''],
      state: [''],
      googleAddress: [''],
      postalCode: [''],
      country: [''],
      suite_no: [''],
      address_contact_no: [''],
      address_alternateContact_no: [''],
    });
  }
  get categoryControls() {
    return (this.form.get('category') as FormArray).controls;
  }
  createCategory() {
    return this.fb.group({
      title: ['', []],
      description: ['']
    });
  }
  public startTime: any;
  public endTime: any;

  getBusinessHours(day) {
    let bdata = this.authenticationService.BusinessData(day);
    this.bhours = bdata;
  }
  addSunItem() {
    this.Sunday = this.formBusiness.get('Sunday') as FormArray;
    this.Sunday.push(this.createSunItem());
    // this.getBusinessHours(this.Sunday)
  }

  addMonItem() {
    this.Monday = this.formBusiness.get('Monday') as FormArray;
    this.Monday.push(this.createMonItem());
    // this.getBusinessHours(this.Monday)
  }
  addTuesItem() {
    this.Tuesday = this.formBusiness.get('Tuesday') as FormArray;
    this.Tuesday.push(this.createTueItem());
    // this.getBusinessHours(this.Tuesday)
  }
  addWedItem() {
    this.Wednesday = this.formBusiness.get('Wednesday') as FormArray;
    this.Wednesday.push(this.createTueItem());
    // this.getBusinessHours(this.Wednesday)
  }

  addThursItem() {
    this.Thursday = this.formBusiness.get('Thursday') as FormArray;
    this.Thursday.push(this.createThurItem());
    // this.getBusinessHours(this.Thursday)
  }
  addFriItem() {
    this.Friday = this.formBusiness.get('Friday') as FormArray;
    this.Friday.push(this.createFriItem());
    // this.getBusinessHours(this.Friday)
  }
  addSatItem() {
    this.Saturday = this.formBusiness.get('Saturday') as FormArray;
    this.Saturday.push(this.createSatItem());
    // this.getBusinessHours(this.Saturday)
  }
  addItem() {
    this.addresses = this.form.get('addresses') as FormArray;
    this.addresses.push(this.createItem());
  }

  addCategory() {
    this.category = this.form.get('category') as FormArray;
    if(this.category.value.length >= 3) this.checkLabel = true;
    if(this.category.value.length <= 2) {
      this.showDiv = false;
      this.category.push(this.createCategory());
    }
    // this.category.reset();
  }
  removeBusinessHour(index, type) {
    if (type == 'Sunday') {
      this.Sunday = this.formBusiness.get('Sunday') as FormArray;
      this.Sunday.removeAt(index);
    } else if (type == 'Monday') {
      this.Monday = this.formBusiness.get('Monday') as FormArray;
      this.Monday.removeAt(index);
    } else if (type == 'Tuesday') {
      this.Tuesday = this.formBusiness.get('Tuesday') as FormArray;
      this.Tuesday.removeAt(index);
    } else if (type == 'Wednesday') {
      this.Wednesday = this.formBusiness.get('Wednesday') as FormArray;
      this.Wednesday.removeAt(index);
    } else if (type == 'Thursday') {
      this.Thursday = this.formBusiness.get('Thursday') as FormArray;
      this.Thursday.removeAt(index);
    } else if (type == 'Friday') {
      this.Friday = this.formBusiness.get('Friday') as FormArray;
      this.Friday.removeAt(index);
    } else if (type == 'Friday') {
      this.Friday = this.formBusiness.get('Friday') as FormArray;
      this.Friday.removeAt(index);
    } else if (type == 'Saturday') {
      this.Saturday = this.formBusiness.get('Saturday') as FormArray;
      this.Saturday.removeAt(index);
    }
  }

  removeItem(index) {
    this.addresses.removeAt(index);
  }
  removeCategory(index) {
    this.category.removeAt(index);
  }
  onChange(event) { }
  deleteCategory(i) {
    this.custCategories.splice(i, 1);
  }
  get f() {
    return this.form.controls;
  }
  //   title = 'rou';
  //   //Local Variable defined
  //   formattedaddress=" ";
  //   options={
  //     componentRestrictions:{
  //       country:["AU"]
  //     }
  //   }
  checkedValue(val1, val2) { }
  keyPress(event) { }

  public communityAddress(address: any) {
    this.zone.run(() => {
      let address_components = address.address_components;
      for (let i = 0; i < address_components.length; i++) {
        if (address_components[i].types[0] == 'administrative_area_level_2') {
          this.address['city'] = address_components[i].long_name;
        } else if (
          address_components[i].types[0] == 'administrative_area_level_1'
        ) {
          this.address['state'] = address_components[i].long_name;
        } else if (address_components[i].types[0] == 'country') {
          this.address['country'] = address_components[i].long_name;
        }
      }
      this.communitySearch.get('city').setValue([this.address['city']]);
      this.communitySearch.get('state').setValue([this.address['state']]);
      this.communitySearch.get('country').setValue([this.address['country']]);
    });
  }
  public addr = {};

  public AddressChange(address: any) {
    console.log("addressss>>>>>>>>>>>", address)
    this.zone.run(() => {
      this.addr['streetAddress'] = address.formatted_address;
      this.addr['address_contact_no'] = address.formatted_phone_number;
      this.addr['address_alternateContact_no'] = '';
      this.addr['googleAddress'] = address.name;
      var latitude = address.geometry.location.lat();
      var longitude = address.geometry.location.lng();
      (this.addressLocation = {
        type: 'Point',
        coordinates: [latitude, longitude],
      }),
        (this.addr['location'] = this.addressLocation);
      let address_components = address.address_components;
      for (let i = 0; i < address_components.length; i++) {
        if (address_components[i]?.types[0] == 'locality') {
          this.addr['city'] = address_components[i].long_name || '';
        } else if (
          address_components[i].types[0] == 'administrative_area_level_1'
        ) {
          this.addr['state'] = address_components[i].long_name || '';
        } else if (address_components[i].types[0] == 'country') {
          this.addr['country'] = address_components[i].long_name || '';
        } else if (address_components[i].types[0] == 'postal_code') {
          this.addr['postalCode'] = address_components[i].long_name || '';
        }
      }
      this.addressMain.controls['googleAddress'].setValue(
        this.addr['googleAddress']
      );
      this.addressMain.controls['city'].setValue(this.addr['city']);
      this.addressMain.controls['state'].setValue(this.addr['state']);
      this.addressMain.controls['streetAddress'].setValue(
        this.addr['streetAddress']
      );
      this.addressMain.controls['postalCode'].setValue(this.addr['postalCode']);
      this.addressMain.controls['country'].setValue(this.addr['country']);
      this.addressMain.controls['address_contact_no'].setValue(
        this.addr['address_contact_no']
      );
      this.addressMain.controls['location'].setValue(this.addressLocation);
      this.hasGoogleSelection = true;
    });
  }

  uploadBanner(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();

      formData.append('image', file, file.name);
      formData.append('imageType', 'coverImage');
      this.ngxService.start();
      this.authenticationService.upload(formData).subscribe(
        (data) => {
          this.ngxService.stop();
          this.coverPhoto = data['data'].url;
          this.form.get('coverPhoto').setValue(this.coverPhoto);
        },
        (error) => {
          this.loading = false;
          if (error.status == 401) {
          } else {
            this.error = error.error.message;
            this.ngxService.stop();
            Swal.fire('Error', 'Oops...', error.error.message);
          }
        }
      );
    } else {
      Swal.fire('Error', 'Oops...');
    }
  }

  uploadProfile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      const formData = new FormData();

      formData.append('image', file, file.name);
      formData.append('imageType', 'profilePic');
      this.ngxService.start();
      this.authenticationService.upload(formData).subscribe(
        (data) => {
          this.ngxService.stop();
          this.profilePic = data['data'].url;
          console.log(this.profilePic, 'this.profilePic')
          this.form.get('photo').setValue(this.profilePic);
        },
        (error) => {
          this.loading = false;
          if (error.status == 401) {
          } else {
            this.error = error.error.message;
            this.ngxService.stop();
            Swal.fire('Error', 'Oops...', error.error.message);
          }
        }
      );
    } else {
      Swal.fire('Error', 'Oops...');
    }
  }
  openProfilePrivacy(content) {
    this.profileModel = this.modalService.open(content, {
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
    });
  }
  openBusinessHour(content) {
    this.businessModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  openCommunityAffiliation(content) {
    this.address = {};
    this.faithId = '';
    this.comAffModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }
  openFaith(content) {
    this.form.controls['faithName'].setValue('Christian');
    this.form.controls['faith'].setValue('Christian');
    this.selectedFaith2 = '';
    this.selectedFaith3 = '';
    let filteredFaith = this.faithList.find((item: any) => item.name =="Christian");
    this.defaultFaithId = filteredFaith._id
    this.selectedFaith = "Christian"
    console.log(filteredFaith)
    this.faithListLevel2 = filteredFaith.subcategory;
    this.faithModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  openCommunity(content) {
    this.community('');
    this.commuinityModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  openSocialLinks(content) {
    this.socialLinksModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  saveSocialLinks() {
    // Social links are already bound to form controls via ngModel
    // Just close the modal
    if (this.socialLinksModel) {
      this.socialLinksModel.close();
    }
  }
  selectFaith(id, name) {
    this.faithId = id;
    this.form.controls['faith'].setValue(name);
    this.communitySearch.controls['faithName'].setValue(name);
  }
  selectComunitty(id, name) {
    this.affiliatedId = id;
    this.form.controls['affiliatedBy'].setValue(name);
  }
  openBusiness(content, event) {
    this.businessList("");
    this.getFaithList();
    let value = event.target.value;
    var nameArr = value.split(',');
    this.modalService
      .open(content, {
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          // this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  openAddress(content, type) {
    if (type == 1) {
      this.isAddress = true;
    }
    else if (type == 2) {
      this.isAddress = false;
      this.alternateAddress.reset();
      // Clear any previously added boxes; we now use a single Address 2 field instead
      this.alternateAddresses = [];
    }
    // Reset modal form and location to avoid stale coordinates
    const emptyLocation: any = { type: 'Point', coordinates: [] };
    this.hasGoogleSelection = false;
    this.addressMain.reset({
      streetAddress: '',
      city: '',
      state: '',
      googleAddress: '',
      postalCode: '',
      country: '',
      suite_no: '',
      address_contact_no: '',
      address_alternateContact_no: '',
      location: emptyLocation,
    });

    this.addModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }
  openAlternateAddress(content) {
    this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }
  addAddress(value) {
    // Require valid Google selection producing coordinates
    if (!(value?.location?.coordinates && value.location.coordinates.length === 2)) {
      Swal.fire('Error', 'Please use Google location (pick from suggestions).');
      return;
    }
    // For main address enforce full details; for Address 2 only coords are required
    if (this.isAddress) {
      if (!value.postalCode) {
        Swal.fire('Error', 'Postal code is required');
        return;
      } else if (!value.streetAddress) {
        Swal.fire('Error', 'street Address name is required');
        return;
      } else if (!value.city) {
        Swal.fire('Error', 'City  is required');
        return;
      } else if (!value.state) {
        Swal.fire('Error', 'State name  is required');
        return;
      }
    }
    if (this.isAddress) {
      this.address = value;
      this.form.controls['address'].setValue(value.streetAddress);
      // Persist main coordinates for submission
      this.form.controls['location'].setValue(value.location);
      this.addressMain.reset();
    }
    else {
      // Do not add to list; just set the single Address 2 field and its coordinates
      if (this.form.get('address2')) {
        this.form.controls['address2'].setValue(value.streetAddress || value.googleAddress || '');
      }
      if (!this.form.get('address2Location')) {
        this.form.addControl('address2Location', new FormControl(null));
      }
      this.form.controls['address2Location'].setValue(value.location || null);
      this.addressMain.reset();
    }

    this.addModel.close();
  }
  removeAddress(i) {
    this.alternateAddresses.splice(i, 1);
  }

  formatAddress(addressObject: any): string {
    return `${addressObject.streetAddress}, ${addressObject.city}, ${addressObject.state}, ${addressObject.postalCode}`;
  }

  upload(file: File) {
    const formData = new FormData();
    formData.append('image', this.form.get('profile').value);
    formData.append('imageType', 'profilePic');
    this.authenticationService.upload(formData).subscribe(
      (data) => {
        let image = data['items'];
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
      }
    );
  }
  public getFaithList(): void {
    this.ngxService.start();
    this.authenticationService.getFaith().subscribe(
      (data) => {
        this.faithList = data['data'];
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
      }
    );
    this.ngxService.stop();
  }
  checkType(val) {
    val != val;
  }
  public businessList(search:any): void {
    this.ngxService.start();
    this.authenticationService.getBusinessType(search).subscribe(
      (data) => {
        this.bussinessList = data['items'];
        this.bussinessList.sort((a, b) => a.category.localeCompare(b.category));
        this.bussinessList.forEach(item => {
            item.name.sort((a, b) => a.tag.localeCompare(b.tag));
        });
        this.newBussinessListData = this.bussinessList;
        this.newBussinessListData = this.bussinessList;
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
      }
    );
    this.ngxService.stop();
  }

  public createBusinessHours(value): void {
    this.getBusinessHours(value);
    let bHours = {};
    if (
      value.Sunday[0].Start == '' &&
      value.Monday[0].Start == '' &&
      value.Tuesday[0].Start == '' &&
      value.Wednesday[0].Start == '' &&
      value.Thursday[0].Start == '' &&
      value.Friday[0].Start == '' &&
      value.Saturday[0].Start == ''
    ) {
      Swal.fire('X', 'Select business hours atleast for one day.');
      return;
    }
    bHours['Sunday'] = value.Sunday;
    bHours['Monday'] = value.Monday;
    bHours['Tuesday'] = value.Tuesday;
    bHours['Wednesday'] = value.Wednesday;
    bHours['Thursday'] = value.Thursday;
    bHours['Friday'] = value.Friday;
    bHours['Saturday'] = value.Saturday;

    this.authenticationService.createBusinessHours(bHours).subscribe(
      (data) => {
        this.communityList = data['items'];
        Swal.fire('', 'Business hours are created sucessfully.', 'success');
        this.businessModel.close();
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
        this.businessModel.close();
      }
    );
  }
  public community_affliation(val): void {
    let obj = {};
    obj['limit'] = '100';
    obj['areaCode'] = val.areaCode;
    obj['city'] = val.city && val.city[0] ? val.city[0] : '';
    obj['state'] = val.state && val.state[0] ? val.state[0] : '';
    obj['country'] = val.country && val.country[0] ? val.country[0] : '';
    obj['long'] = val.long;
    obj['skip'] = '0';
    obj['lat'] = val.lat;
    obj['search'] = val.search;
    obj['faith'] = this.faithId;
    obj['denominiation'] = val.denominiation;
    obj['merchant'] = val.merchant;
    obj['bussinessTypes'] = val.bussinessTypes;
    this.authenticationService.getCommunity(obj).subscribe(
      (data) => {
        this.communityList = data['items'];
        this.comAffModel.close();
        this.communitySearch.reset();
      },
      (error) => {
        if (error.status == 401) {
        } else {
          // $("#" + mod).modal("hide");
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
        this.comAffModel.close();
      }
    );
  }
  public text: string = '';
  searchCommunity(value: string): void {
    this.communityList = [];
    this.ngxService.start();
    this.authenticationService
      .getCommunity({
        search: value,
        skip: '0',
        limit: '100',
      })
      .subscribe(
        (data) => {
          this.communityList = data['items'];
          this.ngxService.stop();
        },
        (error) => {
          if (error.status == 401) {
          } else {
            this.error = error.error.message;
            this.loading = false;
            Swal.fire('Error', 'Oops...', error.error.message);
            if (error.error.message == 'Unauthorized') {
              this.authenticationService.logout();
            }
          }
        }
      );
  }
  savePolicy() {
    let obj = { affiliation: this.affiliation };
    if (this.affiliation == 'fellowshipAffiliates') {
      this.affiliation = 'Felloship(/sign-up)';
    }
    this.authenticationService.profilePolicy(obj).subscribe(
      (response: any) => {
        this.affiliation = response.data.affiliation.privacyType;

        this.profileModel.close();
        Swal.fire('Sucess', 'Policy is added sucessfully', 'success');
      },
      (error) => {
        this.profileModel.close();
        if (error.error.message == 'Unauthorized') {
        }
      }
    );
  }
  public community(event: string) {
    let data = {
      skip: 0,
      limit: 10,
      search: this.text,
    };
    this.ngxService.start();
    this.authenticationService.getCommunities(data).subscribe(
      (data) => {
        this.communityList = data['items'];
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
      }
    );
    setTimeout(() => {
      this.ngxService.stop();
    }, 2500);
  }
  selectBusinessType(categoryId, tagId, tagName) {
    if (tagName) {
      this.bussiness.push(tagName);
      let changeToString = this.bussiness.toString();

      this.businessIds.push({
        categoryId: categoryId,
        tagId: tagId,
        tagName: tagName,
      });
      this.form.controls['bussinessTypes'].setValue(
        this.businessIds[0].tagName
      );
    }
    this.form.get('bussinessTypes')?.reset();
  }

  checkBusiness(val) {
    if (val.target.checked) {
      this.isBusinessContactNameVisible = true;
    } else {
      this.isBusinessContactNameVisible = false;
    }
  }

  checkAddress(val: any) {
    if (val.target.checked) {
      this.isShowStreetAddress = true;
      console.log('isshopw', this.isShowStreetAddress);
    }
    else {
      this.isShowStreetAddress = false;
      console.log('isshopw', this.isShowStreetAddress);

    }
  }

  isValidUrl(userInput) {
    var res = userInput.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
    );
    if (res == null) {
      return false;
    } else {
      return true;
    }
  }
  getInputChange(val:any, name:any) {
    if(val && name == 'description') this.isDescription = false;
    else if(name == 'description') this.isDescription = true;
    if(val && name == 'title') this.isTitle = false;
    else if(name == 'title') this.isTitle = true;
  }
  public onSubmit(values: Object): void {
    let userObj = {};
    this.submitted = true;
    if (!this.form?.value?.faithName) {
      this.form.controls['faithName'].setValue("");
      Swal.fire(
        'Error',
        'Faith name is required.',
        'error'
      );
      return;
    }
    // if (this.form.valid){
    let phonecode = this.form.get('phonecode').value;
    let contactNo = this.form.get('contactNo').value;
    let isUrl = this.isValidUrl(values['website']);

    if (!this.isChecked) {
      Swal.fire(
        'Error',
        'Please select our terms of services and privacy policy to continue.',
        'error'
      );
      return;
    }
    if (contactNo && !phonecode) {
      Swal.fire('Error', 'Phone code is required', 'error');
      return;
    }

    if (this.businessIds.length == 0) {
      Swal.fire('Error', 'Business Type is required', 'error');
      return;
    }
    let phoneNumber = phonecode + contactNo;
    userObj['photo'] = this.profilePic;
    userObj['coverPhoto'] = this.coverPhoto;
    userObj['phonecode'] = phonecode;
    userObj['contactNo'] = contactNo;
    userObj['userName'] = this.form.get('userName').value;
    userObj['name'] = this.form.get('name').value;
    userObj['affiliatedBy'] = this.affiliatedId;
    userObj['faith'] = this.defaultFaithId;
    userObj['subFaith'] = this.selectedFaith2;
    userObj['subFaith2'] = this.selectedFaith3;
    userObj['logLine'] = this.form.get('logLine').value;
    userObj['bussinessTypes'] = this.businessIds;
    userObj['location'] = this.address['location'];
    userObj['website'] = this.form.get('website').value;
    userObj['address'] = this.address;
    userObj['address2'] = this.form.get('address2').value;
  // Attach Address 2 geo if present
  if (this.form.get('address2Location')) {
    userObj['address2Location'] = this.form.get('address2Location').value;
  }
    // userObj['menu'] = this.form.get('menu').value;
    userObj['customCategory'] = this.form.get('category').value;
    userObj['isBusinessContactNameVisible'] = this.isBusinessContactNameVisible;
    userObj['showStreetAddress'] = this.isShowStreetAddress;
    userObj['shortBio'] = this.form.get('shortBio').value;
    userObj['email'] = this.form.get('email').value;
    userObj['subscriptionPlanType'] = this.subscriptionPlanId;
    userObj['businessUserName'] = this.form.get('businessUserName').value;
    // App Store Links
    userObj['iosAppLink'] = this.form.get('iosAppStoreLink').value;
    userObj['androidAppLink'] = this.form.get('androidAppStoreLink').value;
    // Social Profile Links
    userObj['socialProfileLinks'] = {
      facebook: this.form.get('facebookLink').value || '',
      instagram: this.form.get('instagramLink').value || '',
      youtube: this.form.get('youtubeLink').value || '',
      linkedin: this.form.get('linkedinLink').value || '',
      tiktok: this.form.get('tiktokLink').value || ''
    };
    this.ngxService.start();
    this.updateProfile(userObj);
  }
  openFaithValue(){
    this.showDiv = true;
  }
  addArr(obj) {
    this.addresses = this.form.get('addresses') as FormArray;

    this.addresses.push(
      this.fb.group({
        streetAddress: obj.streetAddress,
        suite_no: obj.suite_no,
        city: obj.city,
        location: obj.location,
        state: obj.state,
        googleAddress: obj.googleAddress,
        postalCode: obj.postalCode,
        country: obj.country,
        address_contact_no: obj.address_contact_no,
        address_alternateContact_no: obj.address_alternateContact_no,
      })
    );
  }
  custCat(obj) {
    this.category.removeAt(0);
    this.category = this.form.get('category') as FormArray;

    this.category.push(this.fb.group({
      title: obj.title,
      description: obj.description
    }));

  }

  getBusinessHour(record) {
    if (record && record.Sunday.length > 0) {
      this.Sunday = this.formBusiness.get('Sunday') as FormArray;
      this.Sunday.clear();
      for (let i = 0; i < record.Sunday.length; i++) {
        this.Sunday.push(
          this.fb.group({
            Start: record.Sunday[i].Start,
            Finish: record.Sunday[i].Finish,
          })
        );
      }
    }
    if (record && record.Monday.length > 0) {
      this.Monday = this.formBusiness.get('Monday') as FormArray;
      this.Monday.clear();
      for (let i = 0; i < record.Monday.length; i++) {
        this.Monday.push(
          this.fb.group({
            Start: record.Monday[i].Start,
            Finish: record.Monday[i].Finish,
          })
        );
      }
    }
    if (record && record.Tuesday.length > 0) {
      this.Tuesday = this.formBusiness.get('Tuesday') as FormArray;
      this.Tuesday.clear();
      for (let i = 0; i < record.Tuesday.length; i++) {
        this.Tuesday.push(
          this.fb.group({
            Start: record.Tuesday[i].Start,
            Finish: record.Tuesday[i].Finish,
          })
        );
      }
    }
    if (record && record.Wednesday.length > 0) {
      this.Wednesday = this.formBusiness.get('Wednesday') as FormArray;
      this.Wednesday.clear();
      for (let i = 0; i < record.Wednesday.length; i++) {
        this.Wednesday.push(
          this.fb.group({
            Start: record.Wednesday[i].Start,
            Finish: record.Wednesday[i].Finish,
          })
        );
      }
    }
    if (record && record.Thursday.length > 0) {
      this.Thursday = this.formBusiness.get('Thursday') as FormArray;
      this.Thursday.clear();
      for (let i = 0; i < record.Thursday.length; i++) {
        this.Thursday.push(
          this.fb.group({
            Start: record.Thursday[i].Start,
            Finish: record.Thursday[i].Finish,
          })
        );
      }
    }
    if (record && record.Friday.length > 0) {
      this.Friday = this.formBusiness.get('Friday') as FormArray;
      this.Friday.clear();
      for (let i = 0; i < record.Friday.length; i++) {
        this.Friday.push(
          this.fb.group({
            Start: record.Friday[i].Start,
            Finish: record.Friday[i].Finish,
          })
        );
      }
    }
    if (record && record.Saturday.length > 0) {
      this.Saturday = this.formBusiness.get('Saturday') as FormArray;
      this.Saturday.clear();
      for (let i = 0; i < record.Saturday.length; i++) {
        this.Saturday.push(
          this.fb.group({
            Start: record.Saturday[i].Start,
            Finish: record.Saturday[i].Finish,
          })
        );
      }
    }
  }
  updateProfile(userData) {
    const isfirstSignup = {
      status: 'true',
    };
    localStorage.setItem('mystatus', JSON.stringify(isfirstSignup));
    userData.isEmailPrivate = false;
    this.authenticationService.userRegistration(userData).subscribe(
      (data) => {
        this.ngxService.stop();
        let user = data['data'];
        if (user && user.token) {
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(user.token);
          localStorage.setItem('merchant_token', user.token);
          localStorage.setItem('merchant_currentUser1', JSON.stringify(decodedToken));
          // this.currentUserSubject.next(user);
          this.authenticationService.getUserInfo(user);
        }
        Swal.fire('', 'Please verify your email!', 'success');
        this.router.navigateByUrl('/email-verification');
      },
      (error) => {
        console.log(error);
        this.ngxService.stop();
        if (error.status == 401) {
          // localStorage.removeItem("merchant_currentUser1");
        } else {
          this.error = error.error.message;
          Swal.fire('Error', error.error.message, 'error');
        }
      }
    );
  }

  redirectTo() {
    if (this.user.isFirstUpdateDone) {
      this.router.navigateByUrl('/dashboard');
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  checkImage(usr) {
    if (usr) {
      let pathArray = usr.split('/');
      let protocol = pathArray[0];
      let host = pathArray[2];
      let url = protocol + '//' + host + '/';
      if (
        url == environment.basePath &&
        (protocol == 'https:' || protocol == 'http:')
      ) {
        return usr;
      } else if (protocol == 'uploads') {
        return environment.basePath + usr;
      } else {
        return usr;
      }
    }
  }
  public getMerchantProfile(id): void {
    this.authenticationService.getMerchantById(id).subscribe(
      (data: any) => {
        let user = data['data'];
        if (user.isFirstUpdateDone == true && user.isEmailVarified == true) {
          this.router.navigate(['/dashboard']);
          Swal.fire('', 'User is logged in sucessfully.', 'success');
        } else if (
          user.isFirstUpdateDone == true &&
          user.isEmailVarified == false
        ) {
          this.router.navigate(['/email-verification']);
        }
      },
      (error) => {
        if (error) {
          Swal.fire('Oops...', error.error.message, 'error');
        }
      }
    );
  }
  checkCheckBoxvalue(event) {
    this.isChecked = event.target.checked;
  }

  getSubscription(event: any, content: any) {
    this.subscriptionPlanId = event._id;
    this.selectedPlan = event;
    setTimeout(() => {
      this.modalService.open(content, { size: 'sm' });
    }, 500);
  }

  getSubscriptionPlanType() {
    this.authenticationService.getPlan(true).subscribe((res: any) => {
      // res.data.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));

      let order: Object = {
        "Congregational": 1,
        'Business Builder': 2,
        "Business Quarterly": 3,
        "Community Builder": 4,
        "Founder": 5
      }

      this.subscriptionPlans = res['data'].sort(function (a, b) {
        return order[a.caption] - order[b.caption];
      });

    });
  }


  openFullscreen(content: any) {
    window.scrollTo(0, 0)
    this.modalService.open(content, { size: 'xl', scrollable: true });
  }

  editLabel() {
    if (this.isEdit == false) {
      this.isEdit = true;
    }
    else {
      this.isEdit = false;
    }
  }

  convertSubscripitonType(days: number) {
    if (days === 365) {
      return "Yearly"
    } else if (days === 30) {
      return "Monthly"
    } else if (days === 90) {
      return "Quarterly"
    }
    else if (days === 180) {
      return "Half Yearly"
    }
    return "Days"
  }


  onCountyChange(e: any) {
    let selectedRegion = e.target.value;
    this.newBusinessList = this.bussinessList.filter(item => item.name == selectedRegion)
  }

  onInputChange(event: any) {
    this.businessList(event.target.value);
    // this.bussinessList = this.newBussinessListData.filter((val) =>
    //   val.category.toLowerCase().includes(event.target.value)
    // );
  }

  changeFaith(event: any) {
    // event may be a string (when bindValue is used) or the full object
    const selected = typeof event === 'string'
      ? this.faithList.find((item: any) => item.name === event)
      : event;

    if (!selected) {
      return;
    }

    this.form.controls['faithName'].setValue(selected.name || '');
    this.selectedFaith2 = '';
    this.selectedFaith3 = '';
    const filteredFaith = this.faithList.find((item: any) => item._id == selected?._id || item.name === selected?.name);
    this.faithListLevel2 = filteredFaith?.subcategory || [];
    this.form.controls['subfaithName'].setValue("");
    this.form.controls['subfaith2Name'].setValue("");
  }

  changeSubFaith(event: any) {
    // event may be an id (string) or the full object
    const selected = typeof event === 'string'
      ? this.faithListLevel2.find((item: any) => item._id === event)
      : event;

    if (!selected) {
      return;
    }

    this.form.controls['subfaithName'].setValue(selected.name || '');
    const filteredFaith = this.faithListLevel2.find((item: any) => item._id == selected?._id);
    this.faithListLevel3 = filteredFaith?.subcategory || [];
  }

  changeSubFaith2(event: any) {
    // event may be an id (string) or the full object
    const selected = typeof event === 'string'
      ? this.faithListLevel3.find((item: any) => item._id === event)
      : event;

    if (!selected) {
      return;
    }

    this.form.controls['subfaith2Name'].setValue(selected.name || '');
  }

  openSuggestMinistry(content) {

    this.modalService.dismissAll();
    this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  onMinistrySubmit() {
    this.submitted = true

    let data = {
      name: (this.ministryDetailsForm.value.name) ? (this.ministryDetailsForm.value.name) : '',
      email: (this.ministryDetailsForm.value.email) ? (this.ministryDetailsForm.value.email) : '',
      address: this.ministryAddress ? this.ministryAddress : {},
      phone: (this.ministryDetailsForm.value.phone) ? (this.ministryDetailsForm.value.phone) : '',
      website: (this.ministryDetailsForm.value.companyWebsite) ? (this.ministryDetailsForm.value.companyWebsite) : '',
    }

    this.authenticationService.postData('/user/createCommunity', data).subscribe(
      (result: any) => {
        try {
          if (result.code === 200) {
            Swal.fire('successfully', 'Save Data', 'success');
            this.modalService.dismissAll();
            this.ministryDetailsForm.reset();
            this.affiliatedId = result?.data?._id;
            this.form.controls['affiliatedBy'].setValue(result?.data?.name);
          }
        } catch (error: any) {
          console.log('errorr', error.error);
          Swal.fire('Invalid', `${result.message}`, 'error');
        }
      },
      (error: any) => {
        console.log('erroror', error.error.error);
        Swal.fire();
      }
    )
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }

  // filter google address and patch values for next job address form
  getGoogleAddress(address: any) {
    let addressData: any = [];
    if (address) {
      console.log("place", address)
      address.address_components.find((data: any) => {
        if (data.types.includes('postal_code')) {
          addressData.zipCode = data.long_name
        }
        if (data.types.includes("country")) {
          addressData.country = data.long_name
        }
        if (data.types.includes("administrative_area_level_1")) {
          addressData.state = data.long_name
        }
        if (data.types.includes("locality")) {
          addressData.city = data.long_name
        }
      }
      );

      addressData.formattedAddress = address.formatted_address;
      addressData.name = address.name;
      let arr = address?.formatted_address?.split(',');
      this.invokeEvent(address);
      let lat = address?.geometry?.location.lat();
      let lng = address?.geometry?.location.lng();
      addressData.coordinate = [lat, lng];

      let addressValue = {
        address2: addressData.name ? addressData.name : '',
        city: addressData.city ? addressData.city : '',
        state: addressData.state ? addressData.state : '',
        postalCode: addressData.zipCode ? addressData.zipCode : '',
        country: addressData.country ? addressData.country : '',
        location: {
          type: 'Point',
          coordinates: addressData.coordinate ? addressData.coordinate : ''
        },
        isHidePhone: false,
      }

      this.ministryAddress = addressValue;

    }

    return addressData;
  }

  // get google address
  addressMinistryChange(event) {
    this.addresstextNew = event.target.value
    if (!this.addresstextNew) {
      return
    }

    setTimeout(() => this.getGoogleAddress(this.addresstextNew))

  }

  noWhitespaceOrSpecialCharacter(control) {
    if (control.value && (control.value.trim() !== control.value || !/^[a-zA-Z0-9]*$/.test(control.value))) {
      return { 'whitespaceOrSpecialCharacter': true };
    }
    return null;
  }

}
